export default __webpack_public_path__ + "static/media/gameover.2db06c80.png";